import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';
import configuracionService from '../services/configuracion.service';
import { db } from '../firebase/config';

/**
 * Nombre del negocio para el shell — misma fuente que Header legacy.
 */
export default function useWorkspaceEmpresa() {
  const { orgId } = useAuth();
  const [empresaConfig, setEmpresaConfig] = useState(null);
  const [tenantName, setTenantName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const config = await configuracionService.obtener();
        if (!cancelled) setEmpresaConfig(config);
      } catch (error) {
        console.error('[Workspace] Error al cargar configuración:', error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (!orgId) return;
        const snap = await getDoc(doc(db, 'tenants', orgId));
        if (!cancelled && snap.exists()) {
          setTenantName(snap.data()?.nombre || '');
        }
      } catch (e) {
        console.warn('[Workspace] No se pudo leer tenant:', e.message);
      }
    })();
    return () => { cancelled = true; };
  }, [orgId]);

  const nombreEmpresa = empresaConfig?.nombre_fantasia
    || empresaConfig?.razon_social
    || tenantName
    || '0E3 POS';

  return { nombreEmpresa, loading, empresaConfig };
}
